import * as swcHelpers from '@swc/helpers';
import { Types } from '@grandvisionhq/graphql';
import { getLocalizedString } from '@grandvisionhq/utils';
import { toBaseLineItem } from './base-line-item.js';

const isBundledContactLensesLineItem = (bundledLineItem)=>{
    return 'prescription' in bundledLineItem;
};
const isBundledSolutionLineItem = (bundledLineItem)=>{
    return 'volume' in bundledLineItem.product;
};
var toContactLensesBundleOrderLineItem = (orderLineItem, intl, options = {})=>{
    var ref, ref1, ref2, ref3;
    const base = toBaseLineItem(orderLineItem, intl, options);
    const bundledSolutionLineItem = (ref = orderLineItem.bundledLineItems) === null || ref === void 0 ? void 0 : ref.find(isBundledSolutionLineItem);
    const contactLensesProducts = (ref1 = orderLineItem.bundledLineItems) === null || ref1 === void 0 ? void 0 : ref1.filter(isBundledContactLensesLineItem);
    const leftContactLensesProduct = contactLensesProducts === null || contactLensesProducts === void 0 ? void 0 : contactLensesProducts.find((item)=>item.eyeSide === Types.EyeSide.LEFT || item.eyeSide === Types.EyeSide.BOTH
    );
    const rightContactLensesProduct = contactLensesProducts === null || contactLensesProducts === void 0 ? void 0 : contactLensesProducts.find((item)=>item.eyeSide === Types.EyeSide.RIGHT || item.eyeSide === Types.EyeSide.BOTH
    );
    let prescription = undefined;
    if (rightContactLensesProduct === null || rightContactLensesProduct === void 0 ? void 0 : rightContactLensesProduct.prescription) {
        const _prescription = rightContactLensesProduct.prescription, rightPrescription = swcHelpers.objectWithoutProperties(_prescription, [
            "__typename"
        ]);
        prescription = prescription || {};
        prescription.rightEye = swcHelpers.objectSpread({}, rightPrescription);
    }
    if (leftContactLensesProduct === null || leftContactLensesProduct === void 0 ? void 0 : leftContactLensesProduct.prescription) {
        const _prescription = leftContactLensesProduct.prescription, leftPrescription = swcHelpers.objectWithoutProperties(_prescription, [
            "__typename"
        ]);
        prescription = prescription || {};
        prescription.leftEye = swcHelpers.objectSpread({}, leftPrescription);
    }
    return swcHelpers.objectSpread({}, base, {
        type: 'CONTACT_LENS_BUNDLE',
        productType: 'contact-lenses-bundle-benelux',
        prescription,
        subtitle: `${intl.getLabel('products.monthlySubscription')}`,
        bundleChildLineItems: bundledSolutionLineItem ? [
            {
                title: intl.getLabel('facets.productType.solutions'),
                body: getLocalizedString(bundledSolutionLineItem.product.name, intl.locale),
                price: ((ref2 = bundledSolutionLineItem.price) === null || ref2 === void 0 ? void 0 : ref2.total.gross) || 0,
                originalPrice: ((ref3 = bundledSolutionLineItem.price) === null || ref3 === void 0 ? void 0 : ref3.total.subtotal) || 0
            }, 
        ] : undefined
    });
};

export { toContactLensesBundleOrderLineItem };
//# sourceMappingURL=contact-lenses-bundle-line-item.js.map
